

































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RatingSelectAdvancedHeader extends Vue {
  @Prop({ type: String, default: () => null }) title!: string | null;
  @Prop({ type: String, default: () => null }) selectedItemLabel!:
    | string
    | null;

  private get isCustomFont() {
    return this.$store.getters.isVox;
  }
}
